module.exports = __webpack_public_path__ + "img/madmimi.186fab1c.png";